// frontend/src/components/admin/analytics/TopicScoreList.tsx

import { TopicScore } from '../../../types/studentAnalytics.types';
import { CheckCircle2, AlertTriangle } from 'lucide-react';

interface TopicScoreListProps {
  title: string;
  items: TopicScore[];
  emptyText: string;
  variant: 'strength' | 'weakness';
}

export function TopicScoreList({ title, items, emptyText, variant }: TopicScoreListProps) {
  const isStrength = variant === 'strength';

  return (
    <div className={`topic-list-card ${variant}`}>
      <div className="analytics-section-title">
        {isStrength ? (
          <CheckCircle2 size={20} color="#10b981" />
        ) : (
          <AlertTriangle size={20} color="#f59e0b" />
        )}
        <span>{title}</span>
      </div>

      {items.length === 0 ? (
        <p style={{ color: '#64748b', fontSize: 13, margin: 0, fontStyle: 'italic' }}>{emptyText}</p>
      ) : (
        <div className="topic-rows-container">
          {items.map((item) => (
            <div key={item.topic} className="topic-row-item">
              <div className="topic-name-wrap">
                <span>{isStrength ? '✓' : '⚠️'}</span>
                <span>{item.topic}</span>
              </div>
              <div className={`topic-badge-score ${variant}`}>
                %{item.accuracy} ({item.correct}/{item.total} Doğru)
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
